import "./CoreValuesAccordion.css";

function CoreValuesAccordion() {
  return (
    <div className="accordion" id="coreValuesAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="CustomerCentricity">
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            Customer-Centricity
          </button>
        </h2>
        <div
          id="collapseOne"
          className="accordion-collapse collapse show"
          aria-labelledby="CustomerCentricity"
          data-bs-parent="#coreValuesAccordion"
        >
          <div className="accordion-body">
            We put your needs at the centre of everything we grow. For
            health-conscious and health-challenged consumers and their families,
            it’s affordable nutrition backed by transparency, because trust is
            the foundation of every transaction. For retailers and food service
            providers, this means reliable, high-margin organic produce with
            flexible order sizes and farm-fresh traceability.
          </div>
        </div>
      </div>
      <div className="accordion-item">
        <h2 className="accordion-header" id="Sustainability">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            Sustainability
          </button>
        </h2>
        <div
          id="collapseTwo"
          className="accordion-collapse collapse"
          aria-labelledby="Sustainability"
          data-bs-parent="#coreValuesAccordion"
        >
          <div className="accordion-body">
            Profit and planet thrive together. Our zero-waste farming and
            processing model ensures every harvest delivers value -
            premium-grade produce for your shelves. The "ugly" veggies are
            preserved into profitable processed goods.. Sustainability isn’t
            just our practice—it’s your competitive edge.
          </div>
        </div>
      </div>
      <div className="accordion-item">
        <h2 className="accordion-header" id="Innovation">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            Innovation
          </button>
        </h2>
        <div
          id="collapseThree"
          className="accordion-collapse collapse"
          aria-labelledby="Innovation"
          data-bs-parent="#coreValuesAccordion"
        >
          <div className="accordion-body">
            Standout thrives on responsive, forward-thinking solutions. We blend
            traditional African crops with modern processing techniques and
            leverage low-tech, high-impact tools like WhatsApp commerce. By
            continuously testing and adapting, we redefine what’s possible in
            organic farming and food innovation.
          </div>
        </div>
      </div>
      <div className="accordion-item">
        <h2 className="accordion-header" id="Collaboration">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseFour"
            aria-expanded="false"
            aria-controls="collapseFour"
          >
            Collaboration
          </button>
        </h2>
        <div
          id="collapseFour"
          className="accordion-collapse collapse"
          aria-labelledby="Collaboration"
          data-bs-parent="#coreValuesAccordion"
        >
          <div className="accordion-body">
            Stronger supply chains start with partnership. We work hand-in-hand
            with local farmers, input suppliers, distributors, retailers, and
            health institutions to co-create solutions: customised product
            lines, health-recommended veggie packs, or farm-to-fork marketing
            campaigns. Let’s grow your business while nourishing communities.
          </div>
        </div>
      </div>
      <div className="accordion-item">
        <h2 className="accordion-header" id="Excellence">
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseFive"
            aria-expanded="false"
            aria-controls="collapseFive"
          >
            Excellence
          </button>
        </h2>
        <div
          id="collapseFive"
          className="accordion-collapse collapse"
          aria-labelledby="Excellence"
          data-bs-parent="#coreValuesAccordion"
        >
          <div className="accordion-body">
            Consistency you can count on. On-time, individual and bulk-scale
            deliveries with uncompromising quality. We invest in cutting-edge
            agro-tech and staff training so you receive produce that outperforms
            on flavour, shelf life, and profitability—every order, every time.
          </div>
        </div>
      </div>
    </div>
  );
}

export default CoreValuesAccordion;
